import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import NavigationBar from "@/components/landing/NavigationBar";
import Footer from "@/components/landing/Footer";

const Privacy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Check if we need to scroll to a specific section
    if (location.state && location.state.scrollToId) {
      const element = document.getElementById(location.state.scrollToId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // Otherwise scroll to top
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <NavigationBar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 text-white hover:bg-white/10"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        
        <h1 className="text-3xl font-bold mb-8 text-white">Privacy Policy</h1>
        
        <div className="space-y-6">
          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">Information We Collect</h2>
            <p className="text-gray-300 mb-4">
              We collect information necessary to provide our market research services, including account details and usage data.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">How We Use Your Data</h2>
            <p className="text-gray-300 mb-4">
              Your data is used to provide and improve our services, generate research reports, and enhance the accuracy of our AI analysis.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">Data Protection</h2>
            <p className="text-gray-300 mb-4">
              We implement industry-standard security measures to protect your data and maintain confidentiality.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">Your Rights</h2>
            <p className="text-gray-300 mb-4">
              You have the right to access, correct, or delete your personal data. Contact us to exercise these rights.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">Related Policies</h2>
            <p className="text-gray-300 mb-4">
              Please also review our <Link to="/terms" className="text-blue-400 hover:underline">Terms of Service</Link>, 
              <Link to="/data-processing" className="text-blue-400 hover:underline"> Data Processing Agreement</Link>, and 
              <Link to="/cookie-policy" className="text-blue-400 hover:underline"> Cookie Policy</Link>.
            </p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Privacy;
